import script from "./MissionVisionSection.vue?vue&type=script&setup=true&lang=js"
export * from "./MissionVisionSection.vue?vue&type=script&setup=true&lang=js"

import "./MissionVisionSection.vue?vue&type=style&index=0&id=8ad849de&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ad849de"]])

export default __exports__